/************************************************************************************************************
        DO NOT EDIT THIS FILE
        APPLY YOUR CHANGES TO \common\tasks\image-lib\src\snai-no-logo.svg FILE, INSTEAD
        THEN RUN npm run image-lib COMMAND
    ************************************************************************************************************/
import React from 'react';

export const SnaiNoLogo = ({ className, ...attribs }: React.SVGProps<SVGSVGElement>) => {
  const componentClassName = ['snai-image', 'snai-image-snai-no-logo', className].join(' ');
  return (
    <svg
      id="snai-no-logo"
      width="83"
      height="30"
      viewBox="0 0 83 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      className={componentClassName}
      {...attribs}
    >
      <path
        d="M70.0146 3.5H58.3283C57.0986 3.5 55.8345 4.53008 55.5054 5.80189C55.1762 7.0737 55.9053 8.1049 57.135 8.1049H68.8213C70.051 8.1049 70.7811 9.13609 70.4509 10.4068L69.8548 12.7098H58.7228C55.0336 12.7098 51.2415 15.8023 50.253 19.6177C49.2645 23.4331 51.4538 26.5256 55.1419 26.5256H68.5007C69.7304 26.5256 70.9945 25.4944 71.3236 24.2226L74.9035 10.4068C75.8931 6.59248 73.7038 3.5 70.0146 3.5ZM54.7066 19.6177C55.0358 18.3459 56.2998 17.3147 57.5296 17.3147H68.6583L67.465 21.9207H56.3363C55.1065 21.9207 54.3775 20.8895 54.7066 19.6177V19.6177Z"
        fill="var(--color-on-bg-primary)"
      />
      <path
        d="M50.5393 3.5C49.3096 3.5 48.0455 4.53008 47.7164 5.80189L44.1365 19.6177C43.8074 20.8895 42.5433 21.9207 41.3136 21.9207C40.0839 21.9207 39.3537 20.8895 39.6839 19.6177L42.0695 10.4068C43.058 6.59248 40.8687 3.5 37.1805 3.5C33.4924 3.5 29.7002 6.59248 28.7106 10.4068L25.1308 24.2226C24.8016 25.4944 25.5307 26.5256 26.7604 26.5256C27.9902 26.5256 29.2542 25.4944 29.5834 24.2226L33.1632 10.4068C33.4924 9.13609 34.7564 8.1049 35.9862 8.1049C37.2159 8.1049 37.9449 9.13609 37.6158 10.4068L35.2292 19.6177C34.2407 23.4331 36.43 26.5256 40.1192 26.5256C43.8085 26.5256 47.5995 23.4331 48.5891 19.6177L52.169 5.80189C52.4928 4.53008 51.7626 3.5 50.5393 3.5Z"
        fill="var(--color-on-bg-primary)"
      />
      <path
        d="M0.079035 24.2226C0.40818 22.9508 1.67223 21.9207 2.90197 21.9207H17.3758C18.6055 21.9207 19.8696 20.8895 20.1987 19.6177C20.5279 18.3459 19.7988 17.3147 18.5691 17.3147H8.54997C4.86076 17.3147 2.67253 14.2222 3.66104 10.4068C4.64955 6.59137 8.44061 3.5 12.1309 3.5H24.9322C26.1619 3.5 26.892 4.53008 26.5629 5.80189C26.2338 7.0737 24.9686 8.1049 23.74 8.1049H10.9344C9.70466 8.1049 8.44062 9.13609 8.11147 10.4068C7.78232 11.6775 8.51137 12.7098 9.74111 12.7098H19.7602C23.4494 12.7098 25.6376 15.8023 24.6491 19.6177C23.6606 23.4331 19.8696 26.5256 16.1793 26.5256H1.70547C0.478946 26.5256 -0.25011 25.4944 0.079035 24.2226Z"
        fill="var(--color-on-bg-primary)"
      />
      <path
        d="M82.4056 5.80189C82.7347 4.53008 82.0057 3.5 80.7759 3.5C79.5462 3.5 78.2822 4.53008 77.953 5.80189L73.181 24.2226C72.8507 25.4944 73.5809 26.5256 74.8106 26.5256C76.0403 26.5256 77.3033 25.4944 77.6335 24.2226L82.4056 5.80189V5.80189Z"
        fill="var(--color-on-bg-primary)"
      />
    </svg>
  );
};
export default SnaiNoLogo;
